/// <amd-module name="typeahead/features/AlternateSuggestions" />
/// <amd-dependency path="typeahead/core/loc" name="loc"/>

/// <reference path="../../typings/typeahead/loc.d.ts" />

"use strict";

import {ClientHandlerRegistry} from "typeahead/client/ClientHandlerRegistry";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {IEssSuggestionResult} from "typeahead/core/Suggestion";
import {addFeatureFlag} from "typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils";

const configuration: IStripingConfiguration[] = [
    {
        clients: ["Homepage", "AWSHomepage", "HotelsLandingPage"],
        tabs: ["hotel"],
    },
    {
        clients: ["Hotels.Search"],
        lobs: ["HOTELS"],
    },
];

const featureFlag = "altRegion";

// This feature has to be sent at all times. The user will be bucketed at service level
export class AlternateSuggestions implements IRequestUrlParamModifier, ISuggestionsModifier {
    public modifySuggestions(suggestions: IEssSuggestionResult[], context: IContext, options: any): Object[] {
        if (suggestions && suggestions.length > 0 && ExecutionHelper.shouldExecute(context, configuration)) {
            if (options.renderTrigger === "focus") {
                suggestions.forEach((suggestion: IEssSuggestionResult, index: number): void => {
                    if (suggestion.hierarchyInfo) {
                        let relation = suggestion.hierarchyInfo.relation;
                        if (relation && relation[0] === "alt") {
                            suggestion.showAsHierarchy = true;
                            let prevSuggestion = suggestions[index - 1];
                            if (!prevSuggestion.hierarchyInfo || !prevSuggestion.hierarchyInfo.relation) {
                                // Add a label to the first suggestion of type "alt"
                                suggestion.label = loc.altSuggestionLabelText ?
                                    loc.altSuggestionLabelText : "People also search";
                            }
                        }
                    }
                });
            } else if (options.renderTrigger === "type") {
                suggestions.forEach((suggestion: IEssSuggestionResult, index: number): void => {
                    if (suggestion.hierarchyInfo) {
                        let relation = suggestion.hierarchyInfo.relation;
                        if (relation && relation[0] === "alt") {
                            suggestion.displayGroup = {
                                groupName: "altSuggestion",
                                label: loc.altSuggestionLabelText ?
                                    loc.altSuggestionLabelText : "People also search",
                            };
                        }
                    }
                });
            }
        }
        return suggestions;
    }

    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: any):
            ISuggestServiceQueryParams {
        context.tab = ClientHandlerRegistry.getTab();
        return addFeatureFlag(featureFlag, configuration, params, context, options);
    }
}
